// frontend/admin-portal/src/components/products/ProductStockBadge.jsx
import React from "react";
import { Badge } from "@fiberhome/shared-ui";

export default function ProductStockBadge({ product }) {
  if (!product) return null;
  if (!product.trackStock) return <Badge variant="default">Untracked</Badge>;

  const stock = Number(product.stock) || 0;
  const min = Number(product.minStock) || 0;

  if (stock <= 0) return <Badge variant="danger">Out of Stock</Badge>;
  if (stock <= min) return <Badge variant="warning">Low Stock</Badge>;
  return <Badge variant="success">In Stock</Badge>;
}
